// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2putV","container":"styles_container__1a_5T","title":"styles_title__12F6h","wrapper":"styles_wrapper__2hiPc","answer":"styles_answer__3dDsN"};